// FILE: /src/Components/Redirectpage/Instagram.js (FULLY UPDATED)

import React, { useEffect, useState } from "react";
import { Spin, message, Result, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as authServices from '../../services/authConnect';
import { handleAuthSuccess } from "../../store/Slices/GroupSlice";
import PageSelectionView from "../Public/PageSelectionView";

export default function Instagram() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [status, setStatus] = useState('authenticating');
    const [error, setError] = useState('');
    const [selectionData, setSelectionData] = useState(null);

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const state = params.get('state');

            if (code && state) {
                try {
                    const response = await authServices.handleCallback('INSTAGRAM', code, state);
                    if (response.requiresSelection) {
                        setSelectionData(response);
                        setStatus('selecting');
                    } else {
                        message.success("Instagram reconnected successfully!");
                        dispatch(handleAuthSuccess());
                        navigate('/Dashboard/GroupsProfile');
                    }
                } catch (err) {
                    setError(err.message || 'Failed to verify connection.');
                    setStatus('error');
                }
            } else {
                setError('Authentication was cancelled or failed.');
                setStatus('error');
            }
        };
        handleCallback();
    }, [dispatch, navigate]);

    const handleFinalize = async (selectedItems) => {
        if (selectedItems.length === 0) {
            message.info("Please select at least one account.");
            return;
        }
        setStatus('finalizing');
        try {
            const itemsToFinalize = selectedItems.map(item => ({
                platform: 'INSTAGRAM',
                platform_id: item.id,
                profile: item.username,
            }));

            const result = await authServices.finalize('INSTAGRAM', itemsToFinalize, selectionData.stateToken);

            if (result.partial) {
                message.warning(result.message, 10);
            } else {
                message.success(`${selectedItems.length} account(s) connected successfully!`);
            }

            dispatch(handleAuthSuccess());
            navigate('/Dashboard/GroupsProfile');
        } catch (err) {
            setError(err.message || "Failed to save selected accounts.");
            setStatus('error');
        }
    };

    if (status === 'authenticating' || status === 'finalizing') {
        return (
            <div className="flex flex-col justify-center items-center h-screen">
                <Spin size="large" />
                <p className="mt-4 text-lg text-gray-600">{status === 'finalizing' ? 'Saving profiles...' : 'Authenticating with Instagram...'}</p>
            </div>
        );
    }
    
    if (status === 'error') {
        return (
             <Result
                status="error"
                title="Connection Failed"
                subTitle={error}
                extra={[
                    <Button type="primary" key="console" onClick={() => navigate('/Dashboard/GroupsProfile')}>
                        Go to Brands & Channels
                    </Button>,
                ]}
            />
        );
    }

    if (status === 'selecting') {
        return (
            <PageSelectionView
                accounts={selectionData.instagramAccounts || []}
                platformName="Instagram"
                onFinalize={handleFinalize}
                onCancel={() => navigate('/Dashboard/GroupsProfile')}
                accountNameKey="username"
            />
        );
    }

    return null;
}